import { APIClient } from '@frontend/api-utils';
import { DeceasedStateName, DeceasedTriggerName, IDeceased } from '@frontend/deceased/types';
import { TriggerBody } from '@frontend/workflow/types';

export class DeceasedWorkflowClient extends APIClient {
    public static readonly endpoint = '/deceased-api/v1';

    public static async updateDeceasedState(accountId: string, deceasedId: string, state: DeceasedStateName): Promise<IDeceased> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/deceaseds/${deceasedId}/change-state`, { state });
        return await this.handleResponse<IDeceased>(response);
    }

    public static async triggerDeceasedState(accountId: string, deceasedId: string, trigger: TriggerBody<DeceasedTriggerName>): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/deceaseds/${deceasedId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }
}
